module.exports = __webpack_public_path__ + "static/img/guide04.5cb8f34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c3/guide04.png
// module id = /iWg
// module chunks = 0